import { createClient } from 'contentful'

export const client = createClient({
  space: import.meta.env.VITE_CONTENTFUL_SPACE,
  accessToken: import.meta.env.VITE_ACCESS_TOKEN
});
